import Home from "./pages/Home";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";


function App() {
	return (
		<div>
			<Home />
		</div>
	);
}

export default App;
